import React from "react";
import _ from "lodash";
import { connect } from "formik";
import { TextInput } from "components/Global/FastFormikMaterial";
import loanStatuses from "constants/loanStatuses";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelTextInput = ({ label, fieldName, placeholder, formik, isDisabled, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }
  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label}>
      {isDisabled && <ViewOnlyDiv>{val}</ViewOnlyDiv>}
      {!isDisabled && <TextInput
        fullWidth
        fieldName={fieldName}
        placeholder={placeholder}
        {...otherProps}
      />}
    </LateralField>
  );
};
export default connect(SideLabelTextInput);
